// src/components/hooks/usePageAnalytics.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { backendUrl } from '../config';  // adjust relative path

export function usePageAnalytics() {
  const location = useLocation();

  useEffect(() => {
    const start = Date.now();

    const recordVisit = async () => {
      const duration = Math.max(0, Math.round((Date.now() - start) / 1000));
      try {
        await fetch(`${backendUrl}/admin/analytics`, {
          method: 'POST',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            pagePath: location.pathname,
            sessionDuration: duration
          })
        });
      } catch (err) {
        console.error('Analytics write failed:', err);
      }
    };

    // record on tab/window close or React unmount
    window.addEventListener('beforeunload', recordVisit);
    return () => {
      recordVisit();
      window.removeEventListener('beforeunload', recordVisit);
    };
  }, [location]);
}
